@if (variant() === 'solid') {
  <span [class]="hostClasses()" role="img" [attr.aria-label]="label()">
    <i class="fa-solid fa-hexagon-nodes" aria-hidden="true"></i>
    {{ label() }}
  </span>
} @else {
  <span class="ai-badge--outline-wrapper" [class.ai-badge--outline-wrapper--pro]="isPro()" [class.ai-badge--outline-wrapper--sm]="size() === 'sm'" [class.ai-badge--outline-wrapper--lg]="size() === 'lg'">
    <span [class]="hostClasses()" role="img" [attr.aria-label]="label()">
      <span class="ai-badge__gradient-content">
        <i class="fa-solid fa-hexagon-nodes" aria-hidden="true"></i>
        {{ label() }}
      </span>
    </span>
  </span>
}
